import { Clock } from "@phosphor-icons/react";
import { SettingsCrud } from "./SettingsCrud";

const DAY_LABEL = { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" };

export function WorkSchedulesSettings() {
  return (
    <SettingsCrud
      testid="work-schedules"
      title="Work Schedules"
      icon={Clock}
      description="Define working patterns (days + hours). Stored as configuration only — not yet enforced on attendance or calendars."
      endpoint="/work-schedules"
      subtitle={(w) => {
        const days = (w.working_days || []).map((d) => DAY_LABEL[d] || d).join(", ");
        const hrs = w.start_time && w.end_time ? `${w.start_time}–${w.end_time}` : "";
        return [days, hrs].filter(Boolean).join(" · ");
      }}
      fields={[
        { name: "name", label: "Schedule name", type: "text", required: true, placeholder: "e.g. Standard 9–5" },
        { name: "working_days", label: "Working days", type: "weekdays", default: ["mon", "tue", "wed", "thu", "fri"] },
        { name: "start_time", label: "Start time", type: "time", default: "09:00" },
        { name: "end_time", label: "End time", type: "time", default: "17:00" },
      ]}
    />
  );
}

export default WorkSchedulesSettings;
